<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="dropdownListStatus"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'status'"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Product ID
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="productId"
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Book Type
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'bookType'"
                  [DropDownOptions]="listBookType"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                PPD
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'ppd'"
                  [DropDownOptions]="datesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
              <!-- [selectedOption]="DefaultselectedPPD" -->
            </tr>
            <tr>
              <td class="v-align-m">
                Published Date
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'publishedDate'"
                  [DropDownOptions]="datesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Contracted Date
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'contractedDate'"
                  [DropDownOptions]="datesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Portfolio</th>
          <th scope="col">Publishing Dept Finance</th>
          <th scope="col">Date Created</th>
          <th scope="col">ID</th>
          <th scope="col">Title</th>
          <th scope="col">Brand Id</th>
          <th scope="col">Book Pipeline Status</th>
          <th scope="col">Format</th>
          <th scope="col">Is Derivative</th>
          <th scope="col">Product type</th>
          <th scope="col">Business Unit</th>
          <th scope="col">Length Range</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">ISBN-13E</th>
          <th scope="col">ISBN-10E</th>
          <th scope="col">Product ID</th>
          <th scope="col">Commit Date</th>
          <th scope="col">Contracted Date</th>
          <th scope="col">Handover to Development Date</th>
          <th scope="col">Handover to Production Date</th>
          <th scope="col">Clubbing Completed Date</th>
          <th scope="col">Final Check Completed Date</th>
          <th scope="col">QC Checking Completed Date</th>
          <th scope="col">Final Printers Uploaded Date</th>
          <th scope="col">LS Link Approved Date</th>
          <th scope="col">Cancelled Date</th>
          <th scope="col">Published Date</th>
          <th scope="col">Status</th>
          <th scope="col">EPD</th>
          <th scope="col">PPD</th>
          <th scope="col">PD Accepted</th>
          <th scope="col">Length</th>
          <th scope="col">Preliminary Draft Accepted Date</th>
          <th scope="col">No Of Chapters</th>
          <th scope="col">Book Publisher</th>
          <th scope="col">Video Publisher</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.portfolio}}</td>
          <td>{{product.publishing_dept_finance}}</td>
          <td>{{product.date_entered}}</td>
          <td>{{product.product_id}}</td>
          <td>{{product.product_name}}</td>
          <td>{{product.brand_id}}</td>
          <td>{{product.book_pipeline_status}}</td>
          <td>{{product.product_format}}</td>
          <td>{{product.is_derivative === 1 ? 'true' : 'false' }}</td>
          <td>{{product.book_type}}</td>
          <td>{{product.business_unit}}</td>
          <td>{{product.length_range}}</td>
          <td>{{product.isbn_13}}</td>
          <td>{{product.isbn_10}}</td>
          <td>{{product.isbn_13e}}</td>
          <td>{{product.isbn_10e}}</td>
          <td>{{product.part_number}}</td>
          <td>{{product.commit_date}}</td>
          <td>{{product.contracted_date}}</td>
          <td>{{product.development_date}}</td>
          <td>{{product.production_date}}</td>
          <td>{{product.clubbing_completed_date}}</td>
          <td>{{product.final_check_completed_date}}</td>
          <td>{{product.qc_checking_completed_date}}</td>
          <td>{{product.printers_file_prepared_date}}</td>
          <td>{{product.ipad}}</td>
          <td>{{product.cancelled_date}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product.product_status}}</td>
          <td>{{product.epd}}</td>
          <td>{{product.ppd}}</td>
          <td>{{product.pd_date_percentage}}</td>
          <td>{{product.length_book}}</td>
          <td>{{product.total_pd_accepted}}</td>
          <td>{{product.total_chapters}}</td>
          <td>{{product.book_publisher}}</td>
          <td>{{product.video_publisher}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
